function initPdpGalleryNav() {
  document.querySelectorAll('media-gallery').forEach((mediaGallery) => {
    const viewer = mediaGallery.querySelector('[id^="GalleryViewer-"]:not([id*="duplicate"])');
    if (!viewer) return;

    const slides = [...viewer.querySelectorAll(':scope > ul > li[data-media-id]')];
    if (slides.length < 2) return;

    const dots = [...viewer.querySelectorAll('.pdp-gallery-dots .slider-counter__link')];
    const prevBtn = viewer.querySelector('button[name="previous"]');
    const nextBtn = viewer.querySelector('button[name="next"]');

    function getActiveIndex() {
      return slides.findIndex((s) => s.classList.contains('is-active'));
    }

    function navigateTo(index) {
      if (index < 0 || index >= slides.length) return;
      const targetId = slides[index].dataset.mediaId;
      mediaGallery.setActiveMedia(targetId, false);
      updateDots(index);
      updateArrowState(index);
    }

    function updateDots(activeIndex) {
      dots.forEach((dot) => {
        dot.classList.remove('slider-counter__link--active');
        dot.removeAttribute('aria-current');
      });
      if (dots[activeIndex]) {
        dots[activeIndex].classList.add('slider-counter__link--active');
        dots[activeIndex].setAttribute('aria-current', 'true');
      }
    }

    function updateArrowState(activeIndex) {
      if (prevBtn) {
        if (activeIndex <= 0) {
          prevBtn.setAttribute('disabled', 'disabled');
        } else {
          prevBtn.removeAttribute('disabled');
        }
      }
      if (nextBtn) {
        if (activeIndex >= slides.length - 1) {
          nextBtn.setAttribute('disabled', 'disabled');
        } else {
          nextBtn.removeAttribute('disabled');
        }
      }
    }

    if (prevBtn) {
      prevBtn.addEventListener(
        'click',
        (e) => {
          e.preventDefault();
          e.stopImmediatePropagation();
          const current = getActiveIndex();
          if (current > 0) navigateTo(current - 1);
        },
        true
      );
    }

    if (nextBtn) {
      nextBtn.addEventListener(
        'click',
        (e) => {
          e.preventDefault();
          e.stopImmediatePropagation();
          const current = getActiveIndex();
          if (current < slides.length - 1) navigateTo(current + 1);
        },
        true
      );
    }

    dots.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        navigateTo(index);
      });
    });

    viewer.addEventListener('slideChanged', (event) => {
      const pageIndex = event.detail.currentPage - 1;
      updateDots(pageIndex);
      updateArrowState(pageIndex);
    });

    const observer = new MutationObserver(() => {
      const activeIndex = getActiveIndex();
      updateDots(activeIndex);
      updateArrowState(activeIndex);
    });

    slides.forEach((slide) => {
      observer.observe(slide, { attributes: true, attributeFilter: ['class'] });
    });

    updateArrowState(getActiveIndex());
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initPdpGalleryNav);
} else {
  initPdpGalleryNav();
}
